export default __webpack_public_path__ + "static/media/woodBg.5335f531.png";